import Image from 'next/image'
import styled from 'styled-components'
import heroBgImg from '../../../assets/homepage-v2/DecorMatters-Home-Design-App-Hero-Image.webp'

const HeroWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 935px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 664px;
    justify-content: flex-start;
  }
`

const BackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 704px;
  bottom: 0;
  left: 0;
  z-index: 0;

  @media (max-width: 768px) {
    height: 581px;
    top: 83px;
    bottom: auto;
  }
`

const GradientOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 823px;
  top: 0;
  left: 0;
  background: linear-gradient(360deg, rgba(244, 141, 98, 0) 17%, #f48d62 40%, #f25564 60%, #f74676 79%, #f86286 100%);
  z-index: 1;

  @media (max-width: 768px) {
    height: 516px;
  }
`

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1000px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0 20px;
  margin-top: -100px;

  @media (max-width: 768px) {
    max-width: 319px;
    gap: 20px;
    padding: 0;
    margin-top: 124px;
  }
`

const Title = styled.h1`
  color: white;
  font-size: 68px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.68px;
  text-shadow: 5px 5px 25px rgba(0, 0, 0, 0.17);
  margin: 0;
  line-height: 1.1;

  @media (max-width: 1024px) {
    font-size: 52px;
    letter-spacing: 0.52px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    letter-spacing: 0.28px;
  }
`

const Subtitle = styled.p`
  color: white;
  font-size: 24px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 36px;
  margin: 0;
  max-width: 800px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 19.6px;
    text-transform: none;
  }
`

const DownloadButton = styled.button`
  width: 322px;
  height: 50px;
  background: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 203px;
    height: 42px;
  }
`

const ButtonText = styled.span`
  color: black;
  font-size: 18px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const HeroSection = ({ onDownloadClick }) => {
  return (
    <HeroWrapper>
      <BackgroundImage>
        <Image src={heroBgImg} alt="" layout="fill" objectFit="cover" quality={100} objectPosition="center top" priority />
      </BackgroundImage>
      <GradientOverlay />
      <HeroContent>
        <Title>DecorMatters Home Design App & Decorating Game</Title>
        <Subtitle>Play design games, decorate real rooms, explore ideas, and transform your space with AI.</Subtitle>
        <DownloadButton onClick={onDownloadClick}>
          <ButtonText>Download the App</ButtonText>
        </DownloadButton>
      </HeroContent>
    </HeroWrapper>
  )
}

export default HeroSection
